import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { IPagination } from "./Ipagination";

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.scss"]
})
export class PaginationComponent implements OnInit {
  @Input() pagination: IPagination;

  @Output() pageChanged = new EventEmitter();
  listItem = [];
  current: number;
  prev = false;
  next = true;

  constructor() {}

  ngOnInit() {
    if (!this.listItem.length) {
      for (let i = 1; i <= this.pagination.lastPage; i++) {
        this.listItem.push(i);
      }
      this.current = this.pagination.currentPage;
    }
  }

  choosePage(page) {
    this.current = page;
    this.pageChanged.emit(page);
  }

  previousPage() {
    this.current -= 1;
    this.pageChanged.emit(this.current);
  }

  nextPage() {
    this.current += 1;
    this.pageChanged.emit(this.current);
  }
}

// export class PaginationComponent implements OnInit {
//   @Input() PaginationData: IPagination;

//   @Output() pageCahnge = new EventEmitter();
//   listItem;

//   constructor() {}

//   ngOnInit() {
//     if (this.PaginationData) {
//       this.createListItem();
//       console.log(this.listItem);
//     }
//   }
//   /**
//    * make list of pagnation numbers page
//    */
//   createListItem() {
//     this.listItem = [];
//     this.firstListElement();
//     this.addItemToList();
//   }
//   // current page not 1
//   firstListElement() {
//     if (this.PaginationData.currentPage != 1) {
//       this.prev = true;
//     }
//   }
//   // add 7 pages

//   addItemToList() {
//     let lastAddedPage = this.PaginationData.currentPage + 7;
//     // if last added page big than the last gage
//     lastAddedPage =
//       lastAddedPage > this.PaginationData.lastPage
//         ? this.PaginationData.lastPage
//         : lastAddedPage;

//     for (
//       let index = this.PaginationData.currentPage + 1;
//       index < lastAddedPage;
//       index++
//     ) {
//       this.listItem.push(index);
//     }

//     // if last added page not the last

//     if (lastAddedPage < this.PaginationData.lastPage) {
//       this.listItem.push(this.PaginationData.lastPage);
//     }
//   }

//   /**
//    * emit  new page to parent component
//    * @param item number
//    */
//   ChooseNewPage(item) {
//     this.pageCahnge.emit(item);
//     this.PaginationData.currentPage = item;
//     this.createListItem();
//   }

//   previousPage() {
//     if (this.PaginationData.currentPage == 1) return;
//     let prevPage = this.PaginationData.currentPage - 1;
//     this.ChooseNewPage(prevPage);
//   }

//   nextPage() {
//     if (this.PaginationData.currentPage == this.PaginationData.lastPage) return;
//     let nextPage = this.PaginationData.currentPage + 1;
//     this.ChooseNewPage(nextPage);
//   }
// }
